import { useSelector } from 'react-redux'
import { useFetchBiteClassificationPracticeFlagQuery } from 'store/modules/BiteClassification'

const REFETCH_AFTER_SECONDS = 60

// Practice flag for the selected patient's practice. A failed lookup reads as "off" so HI
// tagging keeps working; the server still enforces the values when the flag is really on.
export default () => {
  const { patient, isLoadingPatient } = useSelector(state => state.patientsReducer)
  const doctorId = patient?.patientDoctorId
  const skip = !doctorId || !!isLoadingPatient
  const { currentData, isError } = useFetchBiteClassificationPracticeFlagQuery(
    { doctorId },
    { skip, refetchOnMountOrArgChange: REFETCH_AFTER_SECONDS }
  )

  return {
    isEnabled: !skip && currentData === true,
    isLoading: !skip && !isError && currentData === undefined,
    isError: !skip && !!isError
  }
}
